import { render, staticRenderFns } from "./Erp6InventorySignboard.vue?vue&type=template&id=3ae74a0b&scoped=true&"
import script from "./Erp6InventorySignboard.vue?vue&type=script&lang=js&"
export * from "./Erp6InventorySignboard.vue?vue&type=script&lang=js&"
import style0 from "./Erp6InventorySignboard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Erp6InventorySignboard.vue?vue&type=style&index=1&id=3ae74a0b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae74a0b",
  null
  
)

export default component.exports